module.exports = __webpack_public_path__ + "img/icon-close.73834a5a.svg";